import { useSearchParams } from 'next/navigation';

import { useQueryParametersForDetailViewBackLink } from '@packages/shared/src/hooks/useQueryParametersForDetailViewBackLink/useQueryParametersForDetailViewBackLink';
import { mergeQueryParameters } from '@packages/shared/src/utils/mergeQueryParameters/mergeQueryParameters';
import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';

import { encodePage } from '../queryEncoding';
import { useOriginalSearchQuery } from './useOriginalSearchQuery';

export const useHrefWithPageNumber = (href: string, pageNumber: number) => {
  const { getProductLinkParams } = useQueryParametersForDetailViewBackLink();
  const searchParams = useSearchParams();
  const query = searchParamsToObject(searchParams);
  const searchQuery = useOriginalSearchQuery();

  return mergeQueryParameters(
    href,
    getProductLinkParams(
      {
        ...query,
        // Page number is included in the query, but the semantic meaning is different for infinite scrolling.
        // The page number included in the query is the "last loaded" page number, while the `pageNumber` from the props is the page the card is located in
        // This is important for back navigation, to load the correct page of products
        ...(pageNumber && encodePage(pageNumber)),
      },
      searchQuery,
    ),
  );
};
